import "./Blogs.module.css";
import Header from "@/reusable_sections/Header";
import Bloghero from "./sections/Bloghero";
import Latestposthighlight from "./sections/Latestposthighlight";
import PostListingGrid from "./sections/PostListingGrid";
import Relatedposts from "./sections/Relatedposts";
import Footer from "@/reusable_sections/Footer";
export default function BlogsPage() {
  return <div>
      <Header />
      <Bloghero />
      <Latestposthighlight />
      <PostListingGrid />
      <Relatedposts />
      <Footer />
    </div>;
}